module.exports = __webpack_public_path__ + "static/img/xinliLogo.cdcbf33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinliLogo.png
// module id = k99D
// module chunks = 18